"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconInvite = function IconInvite(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconInvite', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    d: "M8.533 9.533a3.556 3.556 0 0 1 3.556 3.556v1.422a.711.711 0 0 1-1.422 0V13.09a2.133 2.133 0 0 0-2.134-2.133H3.556a2.133 2.133 0 0 0-2.134 2.133v1.422a.711.711 0 0 1-1.422 0V13.09a3.556 3.556 0 0 1 3.556-3.556zm4.623-4.977c.392 0 .71.318.71.71v1.422h1.423c.36 0 .657.268.705.616L16 7.4a.711.711 0 0 1-.711.711h-1.423v1.422c0 .36-.267.658-.614.705l-.096.006a.711.711 0 0 1-.712-.71V8.11h-1.422a.711.711 0 0 1-.704-.615L10.31 7.4c0-.393.318-.711.711-.711l1.422-.001V5.267c0-.36.268-.658.615-.705zM6.044 1a3.556 3.556 0 1 1 0 7.111 3.556 3.556 0 0 1 0-7.111zm0 1.422a2.133 2.133 0 1 0 0 4.267 2.133 2.133 0 0 0 0-4.267z"
  }));
};

var _default = IconInvite;
exports.default = _default;